import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { Modal, Text, Button } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';
import PhotoGrid from './PhotoGrid.js';

class AddSupportingDocsModal extends PureComponent {
    state = {
        photos: this.props.supportingPhotos || []
    };

    _selectPicture = (files) => {
        const file = new File([ files[0] ], helpers.cleanFilename(files[0].path), { type: files[0].type });
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = async () => {
            await this.setState({
                photos: [ ...this.state.photos, {
                    file,
                    image: reader.result
                }]
            });

            this.props.saveData([ ...this.state.photos ], 'supportingPhotos');
        };
    };

    _removeImage = (index) => {
        const remove = window.confirm('Remove this image from your supporting documents?');

        if (!remove) {
            return;
        }

        this.setState({
            photos: this.state.photos.filter((item, i) => i !== index)
        });

        this.props.saveData([ ...this.state.photos ], 'supportingPhotos');
    };

    render() {
        const { next } = this.props;

        return (
            <Modal
                medium
                testid="submit-claim-modal"
                aria-labelledby="Submit Claim"
                open={true}
                title={ this.props.title }
                primaryButton={{
                    label: "Next",
                    onClick: next
                }}
                onClose={ this.props.onClose}
                loader={ this.props.loader }
                onBack={ this.props.onBack }
            >
                <Text light mediumLarge margin="10px 0 20px 0">
                    {
                        this.props.type === 'HealthSpending' ?
                            'Provide any other documents you may have received from Simply Benefits or another insurance provider regarding this claim.'
                            :
                            'If this claim has already been submitted to another insurer, please include receipts or EOBs you received from the first insurer.'
                    }
                </Text>

                {
                    this.state.photos.length > 0 &&
                            <PhotoGrid
                                photos={this.state.photos}
                                onPressImage={this._removeImage}
                            />
                }

                <div style={{ alignSelf: 'center' }}>
                    <Dropzone
                        onDrop={(files) => this._selectPicture(files)}
                        accept="image/png, image/jpeg, image/jpg, application/pdf"
                    >
                        {({ getRootProps, getInputProps }) => (
                            <section>
                                <div id="dropzone" {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <Button
                                        marginTop={2.5}
                                        marginBottom={2.5}
                                        transparent
                                    >
                                        Select Document
                                    </Button>
                                </div>
                            </section>
                        )}
                    </Dropzone>
                </div>

                <Text light tiny>
                    By submitting this claim I agree to the Simply Benefits Terms of Service.
                </Text>
            </Modal>
        );
    }
}

export default connect()(AddSupportingDocsModal);